import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import Header from './Header';
import Footer from './Footer';
import Home from '../Pages/Home';
import Payments from '../Pages/Payments';
import Players from '../Pages/Players';
import Character from '../Pages/Character';
import Guilds from '../Pages/Guilds';
import Logs from '../Pages/Logs';
import GodMode from '../Pages/GodMode';
import Academy from '../Pages/Academy';
import AFKSystem from '../Pages/AFKSystem';
import Alchemy from '../Pages/Alchemy';
import AutoEvents from '../Pages/AutoEvents';
import BattleArena from '../Pages/BattleArena';
import CaptureTheFlag from '../Pages/CaptureTheFlag';
import Features from '../Pages/Features';
import FortressWar from '../Pages/FortressWar';
import GlobalChat from '../Pages/GlobalChat';
import GMConsole from '../Pages/GMConsole';
import GuildAndUnion from '../Pages/GuildAndUnion';
import Jobs from '../Pages/Jobs';
import Level from '../Pages/Level';
import MasteryLevel from '../Pages/MasteryLevel';
import Notification from '../Pages/Notification';
import PCIPLimit from '../Pages/PCIPLimit';
import Pet from '../Pages/Pet';
import PKSettings from '../Pages/PKSettings';
import PlayerIcon from '../Pages/PlayerIcon';
import ReverseScroll from '../Pages/ReverseScroll';
import ScheduledGifts from '../Pages/ScheduledGifts';
import WhellOfFortune from '../Pages/WhellOfFortune';
import ServerSettings from '../Pages/ServerSettings';
import WebSettings from '../Pages/WebSettings';
import ItemEditor from '../Pages/ItemEditor';
import NPCEditor from '../Pages/NPCEditor';
import Ranks from '../Pages/Ranks';
import RateEditor from '../Pages/RateEditor';
import Regions from '../Pages/Regions';
import WebNews from '../Pages/WebNews';
import WebStore from '../Pages/WebStore';
import AdminRoles from '../Pages/AdminRoles';
import WebDownloads from '../Pages/WebDownloads';
import WebFAQ from '../Pages/WebFAQ';
import Gateways from '../Pages/Gateways';
import Agents from '../Pages/Agents';
import Database from '../Pages/Database';
import DLLSettings from '../Pages/DLLSettings';
import Procedures from '../Pages/Procedures';

// Google Analytics Route Tracker Component
const GARouteTracker = withRouter(({ location }) => {
  React.useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-Z988JD1KBW', { page_path: location.pathname });
    }
  }, [location]);
  return null;
});

class App extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      Pages: [
        { path: `/GodMode`, component: GodMode },
        { path: `/Guilds`, component: Guilds },
        { path: `/Logs`, component: Logs },
        { path: `/ItemEditor`, component: ItemEditor },
        { path: `/NPCEditor`, component: NPCEditor },
        { path: `/Ranks`, component: Ranks },
        { path: `/RateEditor`, component: RateEditor },
        { path: `/Regions`, component: Regions },
        { path: `/WebNews`, component: WebNews },
        { path: `/WebStore`, component: WebStore },
        { path: `/AdminRoles`, component: AdminRoles },
        { path: `/WebDownloads`, component: WebDownloads },
        { path: `/WebFAQ`, component: WebFAQ },
        { path: `/Gateways`, component: Gateways },
        { path: `/Agents`, component: Agents },
        { path: `/Database`, component: Database },
        { path: `/DLLSettings`, component: DLLSettings },
        { path: `/Procedures`, component: Procedures },
        { path: `/WebSettings`, component: WebSettings },
        { path: `/ServerSettings`, component: ServerSettings },
        { path: `/WhellOfFortune`, component: WhellOfFortune },
        { path: `/ScheduledGifts`, component: ScheduledGifts },
        { path: `/ReverseScroll`, component: ReverseScroll },
        { path: `/PlayerIcon`, component: PlayerIcon },
        { path: `/PKSettings`, component: PKSettings },
        { path: `/Pet`, component: Pet },
        { path: `/PCIPLimit`, component: PCIPLimit },
        { path: `/Notification`, component: Notification },
        { path: `/MasteryLevel`, component: MasteryLevel },
        { path: `/Level`, component: Level },
        { path: `/Jobs`, component: Jobs },
        { path: `/GuildAndUnion`, component: GuildAndUnion },
        { path: `/GMConsole`, component: GMConsole },
        { path: `/GlobalChat`, component: GlobalChat },
        { path: `/FortressWar`, component: FortressWar },
        { path: `/Features`, component: Features },
        { path: `/CaptureTheFlag`, component: CaptureTheFlag },
        { path: `/BattleArena`, component: BattleArena },
        { path: `/AutoEvents`, component: AutoEvents },
        { path: `/Alchemy`, component: Alchemy },
        { path: `/AFKSystem`, component: AFKSystem },
        { path: `/Academy`, component: Academy },
        { path: `/Payments`, component: Payments },
        { exact: true, path: `/Players`, component: Players },
        { path: `/Players/:Character`, component: Character },
        { path: `/`, component: Home },
      ],
    };
  }

  render() {
    return (
      <Provider store={this.props.Store}>
        <Router>
          <GARouteTracker />
          <SimpleBar style={{ maxHeight: '100%' }}>
            <Header />

            <Switch>
              {this.state.Pages.map((Page, PageIndex) => (
                <Route {...Page} key={PageIndex} />
              ))}
            </Switch>

            <Footer />
          </SimpleBar>
        </Router>
      </Provider>
    );
  }
}

export default App;
